// extracted by mini-css-extract-plugin
module.exports = {"arrow":"_3b8MG","left":"_1PEaE","right":"_21nj3","chevron":"uPpZy","medium":"_2wxTy","large":"_2DwTT"};